// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=UploadValidateBody|schemaHash=4a02cc621a2c057078fa9f26e814296ae97f6360

import { setDefinedValue } from '@myre/common-primitives';

export function parseUploadValidateBodyFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'fileId', _data.fileId);
  setDefinedValue(result, 'fileName', _data.fileName);

  return result;
}

export function parseUploadValidateBodyToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'fileId', _data.fileId);
  setDefinedValue(result, 'fileName', _data.fileName);

  return result;
}
